export default "__VITE_ASSET__CDg05Ixu__"